var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.896 7.7137V13.2866C7.896 13.6859 8.07829 13.9897 8.44287 14.1981C8.80745 14.4064 9.16336 14.3891 9.51058 14.146L13.8335 11.3856C14.1634 11.1772 14.3283 10.8821 14.3283 10.5002C14.3283 10.1182 14.1634 9.82308 13.8335 9.61475L9.51058 6.85433C9.16336 6.61127 8.80745 6.59391 8.44287 6.80225C8.07829 7.01058 7.896 7.3144 7.896 7.7137ZM10.5002 20.9168C9.05919 20.9168 7.70502 20.6432 6.43766 20.096C5.1703 19.5495 4.06787 18.8075 3.13037 17.87C2.19287 16.9325 1.45086 15.83 0.904329 14.5627C0.357107 13.2953 0.0834961 11.9411 0.0834961 10.5002C0.0834961 9.05919 0.357107 7.70502 0.904329 6.43766C1.45086 5.1703 2.19287 4.06787 3.13037 3.13037C4.06787 2.19287 5.1703 1.45051 6.43766 0.903288C7.70502 0.35676 9.05919 0.0834961 10.5002 0.0834961C11.9411 0.0834961 13.2953 0.35676 14.5627 0.903288C15.83 1.45051 16.9325 2.19287 17.87 3.13037C18.8075 4.06787 19.5495 5.1703 20.096 6.43766C20.6432 7.70502 20.9168 9.05919 20.9168 10.5002C20.9168 11.9411 20.6432 13.2953 20.096 14.5627C19.5495 15.83 18.8075 16.9325 17.87 17.87C16.9325 18.8075 15.83 19.5495 14.5627 20.096C13.2953 20.6432 11.9411 20.9168 10.5002 20.9168Z",
    fill: "#6535E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.ebf00dc673cf756b3e1c15868d9a2e86.svg";
export { ForwardRef as ReactComponent };